import styled from "styled-components";

export const RoundImageContainer = styled.div`
    display:flex;
    gap:10px;
`;

export const RoundBigImage = styled.img`
    border-radius: 50%;
    width: 3.5rem;
    height: 3.5rem;
    object-fit: cover;
`;

export const RoundImage = styled.img`
    border-radius: 50%;
    width: 2.5rem;
    height: 2.5rem;
    object-fit: cover;
`;